// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var green = (_obj = {}, _define_property(_obj, 50, '#EAFAF1'), _define_property(_obj, 100, '#C1F1D5'), _define_property(_obj, 200, '#8BE4B0'), _define_property(_obj, 300, '#57DB8E'), _define_property(_obj, 400, '#2DD272'), _define_property(_obj, 500, '#28BD66'), _define_property(_obj, 600, '#1CA153'), _define_property(_obj, 700, '#198B48'), _define_property(_obj, 800, '#136D38'), _define_property(_obj, 900, '#0E4E28'), _define_property(_obj, 950, '#072714'), _obj);

//# sourceMappingURL=green.js.map